import React from 'react';
import './InvestigationStatusTracker.css';

const InvestigationStatusTracker = ({ status, className }) => {
  const normalizedStatus = status?.toUpperCase() || 'PENDING';
  
  // Map status to step index to ensure consistency
  const getStatusIndex = (status) => {
    // Normalize status to uppercase for consistent comparison
    const normalizedStatus = String(status || '').toUpperCase();
    console.log('Status tracker mapping:', normalizedStatus);
    
    switch (normalizedStatus) {
      case 'PENDING': return 0;
      case 'INVESTIGATION_STARTED':
      case 'STARTED':
      case 'SUBMITTED': return 1; 
      case 'SUPERVISOR_APPROVED': return 2;
      case 'MANAGER_APPROVED':
      case 'COMPLETED': return 3;
      case 'NEEDS_REVISION': return 1; // This goes back to the investigation step
      default: 
        console.log('Unknown status:', normalizedStatus);
        return 0;
    }
  };
  
  const steps = [
    { key: 'PENDING', label: 'Pending' },
    { key: 'INVESTIGATION_STARTED', label: 'Started' },
    { key: 'INVESTIGATION_COMPLETED', label: 'Submitted' },
    { key: 'SUPERVISOR_APPROVED', label: 'Supervisor Approved' },
    { key: 'MANAGER_APPROVED', label: 'Manager Approved' }
  ];
  
  // Get the current step index based on status
  const currentIndex = getStatusIndex(normalizedStatus);
  
  return (
    <div className={`investigation-status-tracker ${className || ''}`}>
      <h4>Investigation Status: {normalizedStatus.replace(/_/g, ' ')}</h4>
      <div className="status-steps">
        {steps.map((step, index) => (
          <div 
            key={step.key}
            className={`status-step ${index <= currentIndex ? 'completed' : ''} ${index === currentIndex ? 'current' : ''}`}
          >
            <div className="step-indicator">{index + 1}</div>
            <div className="step-label">{step.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const InvestigationStatusSection = ({ incident }) => (
  <div className="investigation-status-section">
    <InvestigationStatusTracker 
      status={incident.investigationStatus || 'PENDING'} 
      className="embedded-status-tracker"
    />
  </div>
);

export default InvestigationStatusTracker;
export { InvestigationStatusSection };